import GrossSalesModule from './GrossSales.module';

export default GrossSalesModule;
